import { cn } from "@/lib/class-control";

type PaymentStatus = 'confirmado' | 'pendente' | 'rejeitado' | 'enviado';

interface StatusBadgeProps {
  status: PaymentStatus;
}

const statusConfig: Record<PaymentStatus, { label: string; bgColor: string; textColor: string }> = {
  confirmado: {
    label: 'Confirmado',
    bgColor: 'bg-[#09B068]',
    textColor: 'text-white',
  },
  pendente: {
    label: 'Pendente',
    bgColor: 'bg-[#F2C71E]',
    textColor: 'text-[#0C1427]',
  },
  rejeitado: {
    label: 'Rejeitado',
    bgColor: 'bg-[#B9361C]',
    textColor: 'text-white',
  },
  enviado: {
    label: 'Enviado',
    bgColor: 'bg-[#2078D7]',
    textColor: 'text-white',
  },
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <div className={cn(
      "rounded-[30px] px-[10px] py-[10px] inline-flex items-center justify-center",
      config.bgColor
    )}>
      <p className={cn("text-xs font-bold", config.textColor)}>
        {config.label}
      </p>
    </div>
  );
}
